import moment from 'moment';

// Conversion with special rules for application deadline
export default (date, isUTC = true, keepDate = false) => {
    if (!date) {
        return 'Unknown';
    }

    // Application deadline is usually at hour 00:00,
    // and we do not want the jobad to disappear until the end of the day.
    let momentDate = (isUTC ? moment.utc(date) : moment(date))
        .hour(23)
        .minute(59)
        .second(59);

    if (!momentDate.isValid()) {
        return date === 'Snarest' ? 'Urgent' : date;
    }

    // Check if it is 21 hours left
    // We need to take into account timezones that are potentially 12 hours behind.
    // Job posting is available in cts for 12 hours after end-of-day (utc)
    const now = isUTC ? moment.utc() : moment();
    if (
        now.isAfter(moment(momentDate).subtract(9, 'hours')) &&
        now.isBefore(moment(momentDate).add(12, 'hours')) &&
        !keepDate
    ) {
        return moment(momentDate)
            .add(12, 'hours')
            .fromNow();
    }

    return momentDate.format('LL');
};

// Raw conversion without special rules for application deadline
export function dateToStringRaw(date, isUTC = true) {
    if (!date) {
        return undefined;
    }

    let momentDate = isUTC ? moment.utc(date) : moment(date);

    if (!momentDate.isValid()) {
        return undefined;
    }

    return momentDate.format('LL');
}
